import { Button } from "@/components/core/buttons/button";
import { Form, FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage, FormPrepend } from "@/components/core/forms/form.tsx";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { useEditAddressMutation, useSetBranchMutation, useUpdateSheriffReportMutation } from "@/features/case-record/api/queries/case-records-query";
import courtBranchService from "@/features/court-detail/api/services/court-branches-service";
import { queryClient } from "@/query-client";
import { useState } from "react";
import { useForm } from "react-hook-form";
import DataGrid, { type ColumnDef } from "../core/data-grid";
import Combobox from "../core/forms/combobox";
import DragDropFile from "../core/forms/drag-drop-file";

export default function UpdateSheriffReportModal({
	data,
}: {
	data?: any;
}) {
	const { closeModal } = useModalControl();
	const form = useForm<any>({
		defaultValues: {
			case_record_id: data.id,
			activity_id: data.id,
			court_branch: null,
			court_branch_id: "",
		},
	});
	const [files, setFiles] = useState<File[]>([]);
	const editAddressMutation = useEditAddressMutation();
	const updateSheriffReportMutation = useUpdateSheriffReportMutation();
	const [emailExists, setEmailExists] = useState(false);
	const courtBranch = form.watch("court_branch");

	const advanced = true;

	const regionCode = form.watch("region_code");
	const provinceCode = form.watch("province_code");

	const branchInformationColumns: ColumnDef<any>[] = [
		{
			id: "name",
			label: "Name",
			cell: ({ data }) => <span>{data?.name || "N/A"}</span>,
		},
		{
			id: "category",
			label: "Category",
			cell: ({ data }) => <span>{data?.category || "N/A"}</span>,
		},
		{
			id: "judge",
			label: "Judge",
			cell: ({ data }) => <span>{data?.judge || "N/A"}</span>,
		},
		{
			id: "address",
			label: "Address",
			cell: ({ data }) => <span>{data?.address || "N/A"}</span>,
		},
	];

	const onSubmit = async (dataModel: any) => {
		const formData = new FormData();

		formData.append("data[case_record_id]", data.id);
		formData.append("data[activity_id]", data.id);
		formData.append("data[court_branch_id]", "");

		files.forEach((fileObj, index) => {
			formData.append(`files[${index}][file_id]`, fileObj.file_id);
			formData.append(`files[${index}][preview]`, fileObj.preview);
			formData.append(`files[${index}][file]`, fileObj.file); // this must be a File or Blob object
			formData.append(`files[${index}][name]`, fileObj.name);
			formData.append(`files[${index}][size]`, fileObj.size);
			formData.append(`files[${index}][type]`, fileObj.type);
			formData.append(`files[${index}][date]`, fileObj.date);
		});

		await updateSheriffReportMutation.mutateAsync(formData);
		queryClient.invalidateQueries({ queryKey: ["case_activities"] });
		closeModal();
	};

	console.log(form.formState.errors);

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(onSubmit)}>
				<div className="flex flex-col w-full gap-3">
					<div className="flex flex-col w-full">
						<span className="text-lg font-semibold text-foreground-dark">Sheriff's Report</span>
						<span className="text-base text-foreground/70">Upload updated Sheriff's Report related to this case</span>
					</div>
					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row items-center justify-between w-full gap-4 border-b border-border/50 p-4">
							<DragDropFile
								isCaseFiling={true}
								onSubmit={async (attachments) => {
									setFiles(attachments);
								}}
							/>
						</div>
					</div>
				</div>

				<div className="flex flex-row justify-between w-full pt-4">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" loading={form.formState.isSubmitting}>
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
